import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { EmisoresListComponent } from './emisores-list.component';
import { EmisoresService } from './emisores.service';
import { IEmisor } from './emisor';
import * as myGlobals from './../global';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-emisor',
  templateUrl: './edit-emisor.component.html',
  styleUrls: ['./edit-emisor.component.sass'],
  providers: [EmisoresService]
})
export class EditEmisorComponent implements OnInit, OnDestroy, AfterViewInit {
  emisores: IEmisor[] = [];
  errorMessage = '';
  emisor: IEmisor;

  constructor(public service: EmisoresService, private parent: EmisoresListComponent) {}

  ngOnInit() {
    console.log('EditEmisorComponent: OnInit: id: ', this.parent.editnumber);
    this.getEmisor(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=emisores]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      id: 0,
      issuer: $('input[name=issuer]').val() /* ,
      status: $('#issuer option:selected').val() */
    };
    console.log(formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/card-issuer/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function(response) {
      console.log('delete sucess!!');
      parentRef.showEmisores = true;
      parentRef.showAddEmisor = false;
      parentRef.showEditEmisor = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el emisor: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getEmisor(id: number): any {
    this.service.getEmisor(id).subscribe(emisor => (this.emisor = emisor), error => (this.errorMessage = error as any));
  }

  cancelEmisor(): void {
    this.parent.showEmisores = true;
    this.parent.showAddEmisor = false;
    this.parent.showEditEmisor = false;
  }

  ngOnDestroy() {
    $('a[rel=emisores]').removeClass('selected');
  }
}
